import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito comprar suplementos caros?',
    a: 'No, el método se basa en biología y ejercicios prácticos.'
  }, {
    q: '¿Cuánto tiempo toma ver resultados?',
    a: 'Muchos reportan mejoría desde la primera noche de vaciado mental.'
  }, {
    q: '¿Es difícil de aprender?',
    a: 'No, son pasos mecánicos que cualquier persona puede seguir.'
  }, {
    q: '¿Tengo que dejar de usar mi celular?',
    a: 'Te enseñamos cómo minimizar su daño sin que sea un sacrificio imposible.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="relative z-10 py-24 px-4" data-id="element-31">
      <div className="max-w-3xl mx-auto" data-id="element-32">
        <FadeIn data-id="element-33">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12" data-id="element-34">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-35">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <FadeIn key={index} delay={index * 0.1} data-id="element-36">
                <div className="glass-card overflow-hidden transition-colors duration-300 hover:bg-white/10" data-id="element-37">
                  <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 rounded-2xl" aria-expanded={isOpen} data-id="element-38">
                    <span className="text-lg font-medium text-white pr-4" data-id="element-39">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`w-5 h-5 text-blue-400 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-40" />
                  </button>

                  <AnimatePresence initial={false} data-id="element-41">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-42">
                        <div className="px-6 pb-5 text-gray-400" data-id="element-43">{faq.a}</div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}